import { c } from '../ui-components/src/utils/tailwind-merge';

export const ChevronDown = ({ className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12.6 7.2"
    className={c('ml-auto w-2', className)}
  >
    <path
      className="fill-current"
      transform="matrix(-1 0 0 -1 12.366 7.086)"
      d="m11.421 7.04c-.3 0-.5-.1-.7-.3l-4.6-4.6-4.6 4.6c-.4.4-1 .4-1.4 0s-.4-1 0-1.4l5.2-5.2c.4-.4 1.2-.4 1.6 0l5.2 5.2c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3"
    ></path>
  </svg>
);
